import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IPaginationProps as IEworkitPaginationProps, Pagination as EworkitPagination } from "@/eworkitComponents";

interface IPaginationProps extends IEworkitPaginationProps {}

export const Pagination: FC<IPaginationProps> = props => {
  const { t } = useTranslation("common");

  return (
    <EworkitPagination
      pageNextLabel={t("COMPONENTS.PAGINATION.NEXT")}
      pagePreviousLabel={t("COMPONENTS.PAGINATION.PREV")}
      {...props}
    />
  );
};
